import clsx from 'clsx';
import type { CSSProperties } from 'react';

/** Same path as /favicon.svg; keep them in step. */
const ALPHA_PATH =
  'M52 20 C46 28 44 44 34 47 C22 51 16 38 22 31 C28 24 38 26 41 35 C44 44 46 48 53 45';

function Mark({ className }: { className: string }) {
  return (
    <svg viewBox="0 0 64 64" aria-hidden className={clsx('shrink-0', className)}>
      <title>AlphaDesk</title>
      <rect width="64" height="64" rx="14" className="fill-accent" />
      <path
        d={ALPHA_PATH}
        fill="none"
        stroke="currentColor"
        strokeWidth="7.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="text-canvas"
      />
    </svg>
  );
}

export function Brand({
  size = 'md',
  className,
  style,
}: {
  size?: 'sm' | 'md';
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <span
      className={clsx('flex items-center', size === 'sm' ? 'gap-2' : 'gap-2.5', className)}
      style={style}
    >
      <Mark className={size === 'sm' ? 'size-6' : 'size-7'} />
      <span className="text-sm font-semibold tracking-tight text-ink">AlphaDesk</span>
    </span>
  );
}
